// extracted by mini-css-extract-plugin
module.exports = {"thumb":"ToggleDecorator_thumb__DLpwQ","thumb_large":"ToggleDecorator_thumb_large__HFBh7","root":"ToggleDecorator_root__nC6H_","root_large":"ToggleDecorator_root_large__BM1Yq"};